module.exports = __webpack_public_path__ + "static/media/story_04.d3fcbcb7.jpg";